<template>
  <v-card class="mx-auto" width="256" tile>
    <v-list>
      <v-list-item class="d-flex justify-center">
        <!--<v-list-item-avatar size="80">
            <v-img :src="avatar"></v-img>
          </v-list-item-avatar>-->
        <v-avatar size="80px">
          <img alt="Avatar" :src="avatar" />
        </v-avatar>
      </v-list-item>

      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">{{ perfil.nome }}</v-list-item-title>
          <v-list-item-subtitle>{{ email }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-list nav dense>
      <v-list-item-group color="primary">
        <v-list-item
          v-for="(item, i) in items"
          :key="i"
          @click="processHeaderLink(item)"
        >
          <v-list-item-icon>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title v-text="item.text"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>
<script>
import {
  mdiAccountMultiple,
  mdiPencil,
  mdiExitToApp,
  mdiDatabase
} from '@mdi/js'
export default {
  props: {
    responsive: {
      type: Boolean,
      default: function() {
        return false
      }
    }
  },
  data: () => ({
    item: 0
  }),
  mounted() {
    if (this.responsive) this.items.pop()
  },
  computed: {
    items: function() {
      let myItems = [
        {
          text: 'Trocar Perfil',
          icon: mdiAccountMultiple,
          path: '/selecionarperfil'
        },
        { text: 'Editar Perfil', icon: mdiPencil, path: '/perfil' },
        { text: 'Sair', icon: mdiExitToApp, path: '/' }
      ]
      if (this.userType === 'cliente')
        myItems.unshift({
          text: 'Armazenamento',
          icon: mdiDatabase,
          path: '/armazenamento'
        })
      return myItems
    },
    userType: function() {
      return this.$store.getters.getUserType
    },
    perfil: function() {
      return this.$store.getters.getPerfil
    },
    email: function() {
      return this.$store.getters.getUserLogin
    },
    avatar: function() {
      return this.perfil.foto_perfil && this.perfil.foto_perfil.length > 0
        ? this.perfil.foto_perfil
        : require('@/assets/img/without_image.png')
    },
    accountType: function() {
      return this.$store.getters.getAccountType
    }
  },
  methods: {
    processHeaderLink(item) {
      switch (item.text) {
        case 'Sair':
          this.$store.dispatch('logout', { redirect: true })
          break
        case 'Trocar Perfil':
          this.accountType === 'profissional'
            ? this.$router.push('/signin')
            : this.$router.push(item.path)
          break
        default:
          this.$router.push(item.path)
      }
    }
  }
}
</script>
